'use client';

import { FC } from 'react';
import Socials from '~/components/socials';
import Social from '~/data/strapi/types/single-types/common-data/social-contact';
import { YMGoal, useMetrika } from '~/providers/ya-metrica';
import phoneHref from '~/utils/phone-href';

import styles from './styles.module.css';

interface Props {
  email: string | null;
  phone: string | null;
  socialsData: Social[];
}

const FooterContacts: FC<Props> = ({ email, phone, socialsData }) => {
  const { captureGoal } = useMetrika();

  const onPhoneClick = () => {
    captureGoal(YMGoal.NUMBER_CLICK);
  };

  const onEmailClick = () => {
    captureGoal(YMGoal.EMAIL_CLICK);
  };

  return (
    <div className={styles.contacts}>
      <span className={styles.title}>Контакты</span>
      {phone && (
        <a onClick={onPhoneClick} href={phoneHref(phone)} target="_blank" rel="noreferrer" className={styles.info}>
          {phone}
        </a>
      )}
      {email && (
        <a onClick={onEmailClick} href={`mailto:${email}`} target="_blank" rel="noreferrer" className={styles.info}>
          {email}
        </a>
      )}

      {socialsData && <Socials data={socialsData} iconClassName={styles.socialIcon} />}
    </div>
  );
};

export default FooterContacts;
